import React, { useEffect, useState } from "react";
import moment from 'moment';
import { get } from "lodash";
import { Field } from "redux-form";
import { useNavigate } from "react-router-dom";

import { planList } from "../../helpers/list";
import { getIcon } from "../../helpers/icons";
import { scrollToTop } from "../../helpers/animation";
import { Button, Checkbox, Input } from "../Field";
import Link from "../Link";
import Title from "../Title";
import Spacer from "../Spacer";
import AsyncGet from "../AsyncGet";
import AsyncForm from "../AsyncForm";
import FormatPrice from "./FormatPrice";

import style from "./style.module.css";

export default function Discounts(props) {
    const {  
        nextStep, 
        planId = "", 
        setPaymentIntentDetails ,
        setCouponId,
        setAutorenewal,
        setTotal,
        total,
        setOriginalTotal,
        originalTotal,
        paymentIntentUrl = "",
    } = props;

    const today = moment();
    const navigate = useNavigate();
    const monthExpiry = moment(today).add(1, 'months').format('MMMM D, YYYY');
    const yearExpiry = moment(today).add(1, 'years').format('MMMM D, YYYY');
    const [plan, setPlan] = useState("");
    const [planType, setPlanType] = useState("");
    const [expiry, setExpiry] = useState(monthExpiry);
    const [promoDetail, setPromoDetail] = useState({
        "status": false,
        "id": "",
        "discount_percentage": "",
    });

    useEffect(() => {
        if (planType === 2) {
            setExpiry(monthExpiry)
        }
        else if (planType === 1) {
            setExpiry(yearExpiry)
        }
        // eslint-disable-next-line
    }, [plan])

    useEffect(() => {
        const calculateTotal = () => {
            const baseTotal = parseFloat(total) || 0;
            const discountPercentage = Math.min(parseFloat(promoDetail.discount_percentage) || 0, 99);
            const discount = promoDetail.status
                ? (baseTotal * discountPercentage) / 100
                : 0;

            return (baseTotal - discount).toFixed(2);
        };

        setTotal(calculateTotal());
        // eslint-disable-next-line
    }, [promoDetail]);

    return (
        <div className={style.discounts}>
            <AsyncGet
                url={`/membership/membership-detail/${planId}`}
                permissionText={false}
                loadOnMount={true}
                onError={() => {
                    navigate('/home');
                }}
                onFetch={({ data }) => {
                    setPlan(data.full_title);
                    setTotal(data.price);
                    setOriginalTotal(data.price);
                    setPlanType(data.plan_type);
                }}
                render={() => {
                    return (
                        <AsyncForm
                            id="gstep04"
                            url={paymentIntentUrl}
                            permission={false}
                            showToastOnSuccess={false}
                            onSave={({ data }) => {
                                nextStep('PaymentForm');
                                scrollToTop();
                                setPaymentIntentDetails(data);
                            }}
                            initialValues={{ 
                                auto_renewal: 1 
                            }}
                            paramsData={{
                                coupon_id: promoDetail.id,
                                plan_id: planId,
                            }}
                            render={({ fetching, formValues }) => {
                                return (
                                    <>
                                        <AsyncGet
                                            url="/payment/verify-coupon"
                                            method="post"
                                            permissionText={false}
                                            paramsData={
                                                {
                                                    coupon_code: get(formValues, 'coupon_code', '')
                                                }
                                            }
                                            onFetch={({ data }) => {
                                                if (data.discount_percentage !== undefined) {
                                                    setPromoDetail(prevState => ({
                                                        ...prevState,
                                                        status: true,
                                                        id: data.id,
                                                        discount_percentage: data.discount_percentage
                                                    }));
                                                    setCouponId(data.id);
                                                }
                                            }}
                                            onError={() => {
                                                setPromoDetail(prevState => ({
                                                    ...prevState,
                                                    status: false,
                                                    id: "",
                                                    discount_percentage: ""
                                                }));
                                                setTotal(originalTotal);
                                                setCouponId(null);
                                            }}
                                            render={({ loadFromAPI }) => {
                                                return (
                                                    <>
                                                        <div className={`${style.formRow} ${style.promotionalWrap}`}>
                                                            <Field
                                                                name="coupon_code"
                                                                component={Input}
                                                                placeholder="Enter promotional code"
                                                                label="Have a promotional code?"
                                                            />
                                                            <Link
                                                                className={`${style.applyButton}`}
                                                                onClick={loadFromAPI}
                                                            >
                                                                APPLY
                                                            </Link>
                                                        </div>
                                                        {
                                                            promoDetail.status === true && (
                                                                <div className={style.couponToast}>
                                                                    <div className={`${style.toast} ${style.green}`}>
                                                                        <i className={getIcon("Check")}></i>
                                                                        Promotional code applied
                                                                    </div>
                                                                </div>
                                                            )
                                                        }
                                                    </>
                                                )
                                            }}
                                        />
                                        <div className={style.listWrap}>
                                            <div className={`${style.listItem} ${style.promotionalCodeApplyedAmountDetails}`}>
                                                <div className={style.mainArea}>
                                                    <div className={style.planName}>
                                                        <Title className="fontMontserrat" tag="p">{plan}</Title>
                                                        <Title className="fontMontserrat" tag="p"><FormatPrice planType={planType} price={total} /></Title>
                                                    </div>
                                                    <div className={style.promotionalDescription}>
                                                        <Title className="fontMontserrat" tag="p">
                                                            <span>{plan}</span>
                                                            <span>{planList()[planType || '']}</span>
                                                            <span><FormatPrice planType={planType} price={total} /></span>
                                                            {
                                                                promoDetail.status === true && (
                                                                    <span>{promoDetail.discount_percentage}% Off Promotion</span>
                                                                )
                                                            }
                                                        </Title>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={`${style.listItem} ${style.overallTotal}`}>
                                                <div className={style.mainArea}>
                                                    <div className={style.planName}>
                                                        <Title className="fontMontserrat" transform="textUpperCase" tag="h5">Overall total</Title>
                                                        <Title className="fontMontserrat" tag="h5"><FormatPrice planType={planType} price={total} /></Title>
                                                    </div>
                                                    <div className={style.promotionalDescription}>
                                                        <Title className="fontMontserrat" tag="p">Your {planList()[planType || '']} Subscription will auto renew on {expiry}</Title>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <Spacer size={24} />
                                        <div className={style.formRow}>
                                            <Field
                                                name="auto_renewal"
                                                component={Checkbox}
                                                checkValue={1}
                                                unCheckedValue={0}
                                                label="Enable Auto-Renewal"
                                                onChange={(isChecked) => {
                                                    setAutorenewal(isChecked)
                                                }}
                                            />
                                        </div>
                                        <div className={`${style.formRow} ${style.formSubmit}`}>
                                            <Button
                                                submit={true}
                                                fetching={fetching}
                                                disabled={!total ? true : false}
                                                label="MAKE PAYMENT"
                                            />
                                        </div>
                                    </>
                                )
                            }}
                        />
                    )
                }}
            />
        </div>
    )
}